import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

// Where each role should actually start their day.
const START = {
  cleaner:    [{ to: '/ops/bookings', label: 'Your jobs and their checklists' }],
  dispatcher: [
    { to: '/ops/bookings', label: 'Bookings — take deposits, assign teams, sign off' },
    { to: '/ops/quotes', label: 'Quote requests' },
    { to: '/ops/teams', label: 'Teams' },
  ],
  manager: [
    { to: '/ops/bookings', label: 'Bookings' },
    { to: '/ops/quotes', label: 'Quotes' },
    { to: '/ops/services', label: 'Services & prices' },
    { to: '/ops/reviews', label: 'Reviews awaiting moderation' },
    { to: '/ops/coverage', label: 'Coverage & waitlist' },
    { to: '/admin', label: 'Numbers and setup' },
  ],
};

export default function Dashboard() {
  const { user } = useSelector((s) => s.auth);
  const links = START[user.role] || START.manager;
  return (
    <section className="section">
      <h1>Welcome, {user.name || user.email}</h1>
      <p className="muted">You are signed in as <strong>{user.role}</strong>.</p>
      <div className="card">
        <h2>Start here</h2>
        <ul className="link-list">
          {links.map((l) => <li key={l.to}><Link to={l.to}>{l.label}</Link></li>)}
        </ul>
      </div>
    </section>
  );
}
